import { callEDataVoiceApi } from "./EDVApiClient"

export async function getSearchViewUrl(tenant?: string): Promise<string> {
    try {
        const response = await callEDataVoiceApi<{ url: string }>("customer-profile/search-url", { tenant })
        return response.url ? response.url : ""
    } catch (err) {
        console.error("getSearchViewUrl:", err)
        return ""
    }
}

export async function getCustomerViewUrl(customerId: number, tenant?: string): Promise<string> {
    try {
        const response = await callEDataVoiceApi<{ url: string }>(`customer-profile/profile-url/${customerId}`, { tenant })
        return response.url ? response.url : ""
    } catch (err) {
        console.error("getCustomerViewUrl:", err)
        return ""
    }
}